import {useEffect, useId, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCancel} from "@fortawesome/free-solid-svg-icons/faCancel";
import "../EditCardRibbon.css";
import EditableEntry from "./EditableEntry";

const EditableSelect = ({
                                displayLabel,
                                  items,
                                  onSelect,
                                  placeholder,
                                  defaultValue,
                                  idKey = "id",
                                  nameKey = "name",
                                  cancelButton = false
                              }) => {
    const inputRef = useRef(null);

    const id = useId();

    useEffect(() => {
        inputRef.current.value = defaultValue;
    }, [inputRef, defaultValue]);

    return (
        <EditableEntry
            id={id}
            isEditing={true}
            label={displayLabel}
            editingChildren={
                <>
                    <div className={"noexpand"}>
                        <select id={id} onChange={e => onSelect(e.target.value)} ref={inputRef}>
                            {items.map(item => (
                                <option value={item[idKey]}>{item[nameKey]}</option>))}
                        </select>
                    </div>
                    {cancelButton ? <FontAwesomeIcon className={"stateless-icon-button"} icon={faCancel} onClick={() => {
                        inputRef.current.value = "";
                        onCancel();
                    }}/> : (<></>)}
                </>
            }
        />
    )
}

export default EditableSelect;